/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import * as o from '../output/output_ast';

const CORE = '@angular/core';

export class Identifiers {
  /* Methods */
  static NEW_METHOD = 'factory';
  static TRANSFORM_METHOD = 'transform';
  static PATCH_DEPS = 'patchedDeps';

  /* Instructions */
  static createElement: o.ExternalReference = {name: 'ÉµE', moduleName: CORE};

  static elementEnd: o.ExternalReference = {name: 'Éµe', moduleName: CORE};

  static elementProperty: o.ExternalReference = {name: 'Éµp', moduleName: CORE};

  static elementAttribute: o.ExternalReference = {name: 'Éµa', moduleName: CORE};

  static elementClassNamed: o.ExternalReference = {name: 'Éµkn', moduleName: CORE};

  static elementStyleNamed: o.ExternalReference = {name: 'Éµsn', moduleName: CORE};

  static containerCreate: o.ExternalReference = {name: 'ÉµC', moduleName: CORE};

  static containerEnd: o.ExternalReference = {name: 'Éµc', moduleName: CORE};

  static directiveCreate: o.ExternalReference = {name: 'ÉµD', moduleName: CORE};

  static text: o.ExternalReference = {name: 'ÉµT', moduleName: CORE};

  static directiveInput: o.ExternalReference = {name: 'Éµi', moduleName: CORE};

  static textCreateBound: o.ExternalReference = {name: 'Éµt', moduleName: CORE};

  static bind: o.ExternalReference = {name: 'Éµb', moduleName: CORE};

  static interpolation1: o.ExternalReference = {name: 'Éµi1', moduleName: CORE};
  static interpolation2: o.ExternalReference = {name: 'Éµi2', moduleName: CORE};
  static interpolation3: o.ExternalReference = {name: 'Éµi3', moduleName: CORE};
  static interpolation4: o.ExternalReference = {name: 'Éµi4', moduleName: CORE};
  static interpolation5: o.ExternalReference = {name: 'Éµi5', moduleName: CORE};
  static interpolation6: o.ExternalReference = {name: 'Éµi6', moduleName: CORE};
  static interpolation7: o.ExternalReference = {name: 'Éµi7', moduleName: CORE};
  static interpolation8: o.ExternalReference = {name: 'Éµi8', moduleName: CORE};
  static interpolationV: o.ExternalReference = {name: 'ÉµiV', moduleName: CORE};

  static pureFunction0: o.ExternalReference = {name: 'Éµf0', moduleName: CORE};
  static pureFunction1: o.ExternalReference = {name: 'Éµf1', moduleName: CORE};
  static pureFunction2: o.ExternalReference = {name: 'Éµf2', moduleName: CORE};
  static pureFunction3: o.ExternalReference = {name: 'Éµf3', moduleName: CORE};
  static pureFunction4: o.ExternalReference = {name: 'Éµf4', moduleName: CORE};
  static pureFunction5: o.ExternalReference = {name: 'Éµf5', moduleName: CORE};
  static pureFunction6: o.ExternalReference = {name: 'Éµf6', moduleName: CORE};
  static pureFunction7: o.ExternalReference = {name: 'Éµf7', moduleName: CORE};
  static pureFunction8: o.ExternalReference = {name: 'Éµf8', moduleName: CORE};
  static pureFunctionV: o.ExternalReference = {name: 'ÉµfV', moduleName: CORE};

  static pipeBind1: o.ExternalReference = {name: 'Éµpb1', moduleName: CORE};
  static pipeBind2: o.ExternalReference = {name: 'Éµpb2', moduleName: CORE};
  static pipeBind3: o.ExternalReference = {name: 'Éµpb3', moduleName: CORE};
  static pipeBind4: o.ExternalReference = {name: 'Éµpb4', moduleName: CORE};
  static pipeBindV: o.ExternalReference = {name: 'ÉµpbV', moduleName: CORE};

  static load: o.ExternalReference = {name: 'Éµld', moduleName: CORE};

  static pipe: o.ExternalReference = {name: 'ÉµPp', moduleName: CORE};

  static projection: o.ExternalReference = {name: 'ÉµP', moduleName: CORE};
  static projectionDef: o.ExternalReference = {name: 'ÉµpD', moduleName: CORE};

  static refreshComponent: o.ExternalReference = {name: 'Éµr', moduleName: CORE};

  static directiveLifeCycle: o.ExternalReference = {name: 'Éµl', moduleName: CORE};

  static injectAttribute: o.ExternalReference = {name: 'ÉµinjectAttribute', moduleName: CORE};

  static injectElementRef: o.ExternalReference = {name: 'ÉµinjectElementRef', moduleName: CORE};

  static injectTemplateRef: o.ExternalReference = {name: 'ÉµinjectTemplateRef', moduleName: CORE};

  static injectViewContainerRef:
      o.ExternalReference = {name: 'ÉµinjectViewContainerRef', moduleName: CORE};

  static directiveInject: o.ExternalReference = {name: 'ÉµdirectiveInject', moduleName: CORE};

  static defineComponent: o.ExternalReference = {name: 'ÉµdefineComponent', moduleName: CORE};

  static defineDirective: o.ExternalReference = {
    name: 'ÉµdefineDirective',
    moduleName: CORE,
  };

  static defineInjector: o.ExternalReference = {
    name: 'defineInjector',
    moduleName: CORE,
  };

  static definePipe: o.ExternalReference = {name: 'ÉµdefinePipe', moduleName: CORE};

  static query: o.ExternalReference = {name: 'ÉµQ', moduleName: CORE};
  static queryRefresh: o.ExternalReference = {name: 'ÉµqR', moduleName: CORE};

  static NgOnChangesFeature: o.ExternalReference = {name: 'ÉµNgOnChangesFeature', moduleName: CORE};

  static listener: o.ExternalReference = {name: 'ÉµL', moduleName: CORE};
}
